import { render } from "./DropdownInput.vue?vue&type=template&id=1da980f7"
import script from "./DropdownInput.vue?vue&type=script&lang=js"
export * from "./DropdownInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__